/**Qualtrics Implementation */
import Express from "@Meridian-Developers/meridian-ui/middleware_controller";

class SurveyHelper {
    async setupCookies(cookies) {
        try {
            const sessionData = await Express.call("fetch-idea-session", {
                sessionId: Express.getSessionId(),
            });

            const { userId, accountContext } = sessionData;

            const user = await Express.call("fetch-user", {
                userId: userId,
            });

            if (!user || !accountContext) {
                return { error: "User or account listing not found" };
            }

            cookies.set(
                "sjg-qualtrics-account-number",
                accountContext.accountId,
                { path: "/" }
            );
            cookies.set(
                "sjg-qualtrics-customer-name",
                accountContext.customerName,
                { path: "/" }
            );

            // manually set using no library to avoid encoding '@' symbol
            document.cookie = `sjg-qualtrics-email=${user.emails[0].address}; path=/`;

            cookies.set("sjg-qualtrics-userid", user.username, { path: "/" });

            return { success: true };
        } catch (error) {
            console.error("Error setting up cookies:", error);
            return { error: "Failed to set up cookies" };
        }
    }
}

export default new SurveyHelper();
